import { createFileRoute } from '@tanstack/react-router';
import { UserX } from 'lucide-react';
import { PageHeader } from '@/components/page-header';
import { EmptyState } from '@/components/ui/empty-state';
import { ProfileView } from '@/features/employees/profile/profile-view';
import { profileSearchSchema } from '@/features/employees/profile/route-search';
import { useAuth } from '@/lib/auth';
import { guardRoute } from '@/lib/route-guards';

/** My profile (FR-EMP-7, FR-SAL-7): own record, own salary read-only. */
export const Route = createFileRoute('/_app/me')({
  validateSearch: profileSearchSchema,
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/me');
  },
  component: MyProfilePage,
});

function MyProfilePage() {
  const { user } = useAuth();
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  if (!user?.employeeId) {
    return (
      <div>
        <PageHeader title="My profile" />
        <EmptyState
          icon={UserX}
          title="No employee record"
          hint="This account is not linked to an employee."
        />
      </div>
    );
  }
  return (
    <ProfileView
      employeeId={user.employeeId}
      tab={tab}
      onTabChange={(next) => {
        void navigate({ search: { tab: next }, replace: true });
      }}
    />
  );
}
